// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/img/preloader.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preloader {
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 200;
  /* &:after{
     content:"";
     position: absolute;
     width: 100%;
     height:100%;
     background: #FCEEE3;
     opacity: 1;
     z-index: 0;
   }*/
}
.preloader__wrapper {
  position: relative;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.preloader__img {
  position: relative;
  width: 150px;
  height: 89px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  background-size: cover;
  animation: 1s preloader steps(2) infinite;
  margin-bottom: 30px;
  border: none;
}

@keyframes preloader {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: -305px 0;
  }
}
@media (max-width: 767px) {
  @keyframes preloader {
    0% {
      background-position: 0 0;
    }
    100% {
      background-position: -305px 0;
    }
  }
}
.preloader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--primary-color);
}
.preloader.relative {
  position: relative;
  border-radius: 8px;
}
.preloader.fixed {
  position: fixed;
  z-index: 200;
}
.preloader.absolute {
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/Preloader/Preloader.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EAGA;;;;;;;;KAAA;AAKF;AAIE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAFJ;AAIE;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,6DAAA;EACA,sBAAA;EACA,yCAAA;EACA,mBAAA;EACA,YAAA;AAFJ;;AAMA;EACE;IACE,wBAAA;EAHF;EAKA;IACE,6BAAA;EAHF;AACF;AAOA;EACE;IACE;MACE,wBAAA;IALF;IAOA;MACE,6BAAA;IALF;EACF;AACF;AAUA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gCCzEK;ADiEP;AASE;EACE,kBAAA;EACA,kBAAA;AAPJ;AASE;EACE,eAAA;EACA,YAAA;AAPJ;AASE;EACE,kBAAA;AAPJ","sourcesContent":["@import '../../../styles/_variables';\r\n@import '../../../styles/_variables';\r\n.preloader{\r\n  position:fixed;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 200;\r\n\r\n\r\n  /* &:after{\r\n     content:\"\";\r\n     position: absolute;\r\n     width: 100%;\r\n     height:100%;\r\n     background: #FCEEE3;\r\n     opacity: 1;\r\n     z-index: 0;\r\n   }*/\r\n  &__wrapper{\r\n    position: relative;\r\n    z-index: 3;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n  &__img{\r\n    position: relative;\r\n    width: 150px;\r\n    height: 89px;\r\n    background: url(../../../assets/img/preloader.png) no-repeat;\r\n    background-size: cover;\r\n    animation: 1s preloader steps(2) infinite;\r\n    margin-bottom: 30px;\r\n    border:none;\r\n\r\n  }\r\n}\r\n@keyframes preloader {\r\n  0%{\r\n    background-position: 0 0;\r\n  }\r\n  100%{\r\n    background-position: -305px 0;\r\n\r\n  }\r\n}\r\n\r\n@media (max-width:767px){\r\n  @keyframes preloader {\r\n    0%{\r\n      background-position: 0 0;\r\n    }\r\n    100%{\r\n      background-position:  -305px 0;\r\n\r\n    }\r\n  }\r\n}\r\n\r\n\r\n.preloader{\r\n  position: fixed;\r\n  top:0;\r\n  left:0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 100;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background: $main;\r\n  &.relative{\r\n    position:relative;\r\n    border-radius: 8px;\r\n  }\r\n  &.fixed{\r\n    position:fixed;\r\n    z-index: 200;\r\n  }\r\n  &.absolute{\r\n    position:absolute;\r\n  }\r\n}","$main: var(--primary-color);\r\n$accent:  var(--accent-color);\r\n$additional: var(--additional-color);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
